import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { AgChartOptions } from "ag-charts-community";
import { AgCharts } from "ag-charts-react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional Theme applied to the grid
import "ag-grid-enterprise";
import { useTheme } from "next-themes";
import { useMemo } from "react";

const CounterpartyBarChart = ({
  filteredData,
}: {
  filteredData: IBaseAnalyticsCombined[];
}) => {
  const { theme } = useTheme();
  const options = useMemo<AgChartOptions | any>(() => {
    return {
      background: {
        visible: false,
      },
      data: filteredData,
      theme: theme == "dark" ? "ag-default-dark" : "ag-default",
      series: [
        {
          type: "bar",
          xKey: "counterparty",
          yKey: "DV01Won",
          yName: "DV01Won",
          fill: theme == "dark" ? "#5F3113" : "#A97456",
          // fill: "#FC6A08",
          direction: "vertical",
          highlightStyle: {
            item: {
              fill: "#FC6A08", // Change fill color on hover - Cube Orange
            },
          },
        },
      ],
      axes: [
        {
          type: "category",
          position: "bottom",
        },
        {
          type: "number",
          position: "left",
          label: {
            formatter: (params: any) => {
              // Example: Format with commas
              return "$" + params.value.toLocaleString();
              // Example: Shorten large numbers
              // if (params.value >= 1000000) return (params.value / 1000000).toFixed(1) + "M";
              // if (params.value >= 1000) return (params.value / 1000).toFixed(1) + "K";
              // return params.value;
            },
          },
        },
      ],
      legend: {
        position: "bottom",
        enabled: false,
      },
    };
  }, [theme, filteredData]);
  return (
    <div className="flex h-full w-full">
      <AgCharts className="flex h-full w-full" options={options} />
    </div>
  );
};

export default CounterpartyBarChart;
